import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, resolveImg } from "@/lib/api";
import { Reveal } from "@/components/site/Reveal";
import { PageHero } from "@/components/site/PageHero";
import { Seo } from "@/components/site/Seo";

export default function Learn() {
  const [articles, setArticles] = useState([]);
  useEffect(() => {
    api.get("/articles").then((r) => setArticles(r.data)).catch(() => {});
  }, []);

  return (
    <div>
      <Seo title="Learn — Education & Articles | Psalm 30:2 Chiropractic" description="Functional movement education, recovery insights and clinical thinking from Psalm 30:2 Chiropractic in Gardner, Kansas." />
      <PageHero eyebrow="Learn" title={<>Education &<br />clinical thinking.</>} intro="Articles, movement education and community initiatives from the Psalm 30:2 team." />
      <section className="bg-ivory pb-28 px-6 md:px-10 lg:px-14" data-testid="learn-grid">
        <div className="max-w-[1500px] mx-auto grid sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-14">
          {articles.map((a, i) => (
            <Reveal key={a.slug} delay={(i % 3) * 70}>
              <Link to={`/learn/${a.slug}`} className="group block" data-testid={`article-card-${a.slug}`}>
                <div className="overflow-hidden rounded-sm aspect-[3/2] mb-5">
                  <img src={resolveImg(a.cover_image)} alt={a.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-1000" loading="lazy" />
                </div>
                <div className="overline mb-2">{a.category}</div>
                <h3 className="font-serif text-2xl lg:text-3xl text-espresso group-hover:text-taupe transition-colors leading-tight">{a.title}</h3>
                <p className="mt-2 text-espressosoft/70 font-light leading-relaxed">{a.excerpt}</p>
              </Link>
            </Reveal>
          ))}
        </div>
        {articles.length === 0 && <p className="max-w-[1500px] mx-auto text-taupe font-light">Articles are coming soon.</p>}
      </section>
    </div>
  );
}
